<template>
  <div class="container chart">
    <div class="card" v-if="loaded" id="card-chart" style="height: 250px">
      <div class="d-flex">
        <h5 class="chart-title" style="padding: 10px 15px">HOURS BY MONTH</h5>
        <router-link
          class=""
          :to="'/clients/' + this.$route.params.id + '/report'"
          style="padding: 10px 15px; font-size: 15px"
          >more details</router-link
        >
      </div>
      <lineChart :data="chartData" :height="200"></lineChart>
    </div>
    <div class="card" v-if="loaded" id="card-chart" style="height: 250px">
      <div class="d-flex">
        <h5 class="chart-title" style="padding: 10px 15px">HOURS BY PROJECT</h5>
        <router-link
          class=""
          :to="'/clients/' + this.$route.params.id + '/report'"
          style="padding: 10px 15px; font-size: 15px"
          >more details</router-link
        >
      </div>
      <barChart :data="barChartData" :height="200"></barChart>
    </div>
  </div>
</template>

<script>
import lineChart from "./charts/WeeklySupport.vue";
import barChart from "./charts/TaskSupport.vue";
import { useEntriesStore } from "../stores/entries.js";
import { storeToRefs } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ClientCharts",
  setup() {
    const entriesStore = useEntriesStore();
    const { barChartData, chartData, loaded } = storeToRefs(entriesStore);
    const { fetchRecap } = entriesStore;
    fetchRecap();
    return {
      entriesStore,
      barChartData,
      chartData,
      loaded,
    };
  },
  components: {
    lineChart,
    barChart,
  },
});
</script>
